module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAGdJREFUWEdjZBgEgHEQuIFh1BGwWCArJJb3V/7HF42Rhe0kmUuSYpjFo44YDQn0RDiaJgZVmqB2UT9aTowW2+hpajRNjKYJqqSJ0cJqUNUdo1X5aHSMNu+oXSjhMo+sWpTajhsUjgAA7WtgIv7LefsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat-images/seat/wall.png
// module id = RYj4
// module chunks = 1